import {emptyGuid} from "../../../../../Utilities/commonUtilities";
import {BRAILLER_STATUS} from "../braillerCatalogItemConstants";

export const getBraillerInventoryItemId = (inventoryItem: Record<string, any>, index: number) => {
    return inventoryItem.braillerInventoryId && inventoryItem.braillerInventoryId !== emptyGuid
        ? inventoryItem.braillerInventoryId
        : `inventory-item-${index}`;
};

export const canDeleteInventoryItem = (item: Record<string, unknown>) => {
    return item.status === BRAILLER_STATUS.Available || item.status === 0;
};
